class reflashAndBackControl {

    /**
     * 새로고침, 뒤로가기 막기 추가
     */
    handlerSetReflashAndBack = () => {
        if (touchennxwebpolicyinfo.hasOwnProperty('ViewSource')) {
            delete touchennxwebpolicyinfo.ViewSource
        }
        touchennxwebpolicyinfo['ReflashNBack'] = 0x00001000
        this.setTouchEnNxReflashAndBack();
        TouchEnNx.success({success: "true"});
        window.addEventListener('mouseup', this.setBackStopMouseEvent)
        window.addEventListener('keydown', this.setBackStopKeyEvent)
    }

    /**
     * 새로고침, 뒤로가기 막기 해제
     */
    handlerDelReflashAndBack = () => {
        if (touchennxwebpolicyinfo.hasOwnProperty('ReflashNBack')) {
            delete touchennxwebpolicyinfo.ReflashNBack
        }
        touchennxwebpolicyinfo['ViewSource'] = 0x00000020 /*개발자도구 막기 해제*/
        this.setTouchEnNxReflashAndBack();
        TouchEnNx.success({success: "true"});
        window.removeEventListener('mouseup', this.setBackStopMouseEvent)
        window.removeEventListener('keydown', this.setBackStopKeyEvent)
    }

    /**
     * 라온프로그램 새로고침, 뒤로가기 제어 관련 세팅
     */
    setTouchEnNxReflashAndBack = () => {
        touchennxwebpolicy = null;
        for (let key in touchennxwebpolicyinfo) {
            touchennxwebpolicy = (touchennxwebpolicy == null) ? touchennxwebpolicyinfo[key] : touchennxwebpolicy | touchennxwebpolicyinfo[key];
        }
        touchennxwebparams[1] = touchennxwebpolicy + ""
    }

    /**
     * 마우스 이벤트로 뒤로가기 막기
     * @param e
     */
    setBackStopMouseEvent = (e) => {
        if (e.button === 3) {
            e.preventDefault();
        }
    }

    /**
     * 키보드 이벤트로 뒤로가기 막기
     * @param e
     */
    setBackStopKeyEvent = (e) => {
        // const isWindow = navigator.userAgent.includes('Windows');
        const isMac = navigator.userAgent.includes('Mac');
        if (isMac) {
            if ((e.metaKey && e.key === '[') || (e.metaKey && e.key === 'ArrowLeft')) {
                e.preventDefault();
            }
            if ((e.metaKey && e.key.toLowerCase() === 'r') || (e.metaKey && e.shiftKey && e.key.toLowerCase() === 'r')) {
                e.preventDefault();
            }
        } else {
            if (e.altKey && e.keyCode === 37) {
                e.preventDefault();
            }
        }
    }
}

export default new reflashAndBackControl();